<template>
    <div>
        <input id="radio-1" class="hidden" name="radio-group" type="radio" value=true v-model="radio" @change="sendFeedback">
        <label for="radio-1" class="mx-6"> <i class="far fa-2x fa-thumbs-up"></i></label>
        <input id="radio-2" class="hidden" name="radio-group" type="radio" value=false v-model="radio" @change="sendFeedback">
        <label for="radio-2" class="mx-6"><i class="far fa-2x fa-thumbs-down"></i></label>
    </div>
</template>

<script>
const axios = require('axios');
export default {
    name:'feedback',
    props:['laravelUrl', 'wpUserId', 'articleId'],
    data: function() {
        return{
            radio: null
        }
    },

    methods: {
        sendFeedback() {
            axios.post(this.laravelUrl + '/api/feedback',{
                is_useful:this.radio == "true" ? true: false,
                wp_user_id: this.wpUserId,
                wp_article_id: this.articleId
            })
            .then(function (response) {
                // handle success
                console.log(response);
            });

            console.log(this.radio)
        }
    },

    mounted: function () {
    }

}
</script>